import { render, staticRenderFns } from "./DashBoardAsesor.vue?vue&type=template&id=615d8da6&scoped=true"
import script from "./DashBoardAsesor.vue?vue&type=script&lang=js"
export * from "./DashBoardAsesor.vue?vue&type=script&lang=js"
import style0 from "./DashBoardAsesor.vue?vue&type=style&index=0&id=615d8da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615d8da6",
  null
  
)

export default component.exports